import { render, staticRenderFns } from "./HubPendingApprovalListTable.vue?vue&type=template&id=1bd5d0ba"
import script from "./HubPendingApprovalListTable.vue?vue&type=script&lang=js"
export * from "./HubPendingApprovalListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports